import React from "react";
import {themeTokens} from "@octopusdeploy/design-system-tokens";
import {BetterUptimeStatus} from "client/resources/betterUptimeStatus";

import {HeartIcon, ExclamationCircleIcon, TimeCircleIcon} from "@octopusdeploy/design-system-icons";

const iconColor = themeTokens.color.icon;
const textColor = themeTokens.color.text;

export function getBetterUptimeColorFor(status: BetterUptimeStatus, active = true): string {
    if (!active)
        return textColor.tertiary;

    switch (status) {
        case BetterUptimeStatus.Up:
            return textColor.success;
        case BetterUptimeStatus.Down:
        case BetterUptimeStatus.Paused:
        case BetterUptimeStatus.Unknown:
            return textColor.danger;
        case BetterUptimeStatus.Pending:
        case BetterUptimeStatus.Maintenance:
        case BetterUptimeStatus.Validating:
            return textColor.warning;
    }
}

export function getBetterUptimeIconFor(status: BetterUptimeStatus, active: boolean): JSX.Element {
    switch (status) {
        case BetterUptimeStatus.Up:
            return <HeartIcon size={24} color={active ? iconColor.success : iconColor.tertiary}/>
        case BetterUptimeStatus.Down:
        case BetterUptimeStatus.Paused:
        case BetterUptimeStatus.Unknown:
            return <ExclamationCircleIcon size={24} color={active ? iconColor.danger : iconColor.tertiary}/>
        case BetterUptimeStatus.Pending:
        case BetterUptimeStatus.Maintenance:
        case BetterUptimeStatus.Validating:
            return <TimeCircleIcon size={24} color={active ? iconColor.warning : iconColor.tertiary}/>
    }
}
